import React from 'react';
import {Tag} from './styles';

export default ({
  name,
  color,
  theme,
  size,
  fontSize,
}: {
  name: string;
  color?: string;
  theme?: string;
  size?: string;
  fontSize?: string;
}) => (
  <Tag color={color} theme={theme} size={size} fontSize={fontSize}>
    {name}
  </Tag>
);
